import * as Sentry from '@sentry/browser';
import { getClientContext } from '@utils/get-client-context';

export function handleApiError(
  method: string,
  url: string,
  message: string,
): never {
  const err = new Error(message);
  err.name = 'HttpErrorResponse';

  console.error(err);

  Sentry.withScope((scope) => {
    scope.setTransactionName(`${method} ${url}`);
    scope.setContext('client', getClientContext());
    Sentry.captureException(err);
  });

  throw err;
}
